const getPreferenceCenterPhoneNumberInput = require("./getPreferenceCenterPhoneNumberInput");
const createHTMLElement = require("../dom/createHTMLElement");

/**
 * @param preferenceCenter {HTMLElement}
 * @return {void}
 */
module.exports = function appendPreferenceCenterPhoneNumberFormatMessage(preferenceCenter) {
    const phoneInput = getPreferenceCenterPhoneNumberInput(preferenceCenter);
    const formatMessage = createHTMLElement(`<div data-component="phoneNumberFormatMessage" style="margin-top: 0.25rem; font-size: 85%;">Please use format +12345678901`);
    phoneInput.after(formatMessage)
}